import React from "react";
import { useSelector } from "react-redux";
import useTranslation from "../../hooks/useTranslation";

const VideoCall = () => {
  const { t } = useTranslation();
  const { videoCallHistory } = useSelector((state) => state.videoCallHistory);

  return (
    <div style={{ padding: "16px", maxWidth: "600px", margin: "0 auto" }}>
      {videoCallHistory?.length > 0 ? (
        videoCallHistory.map((data, index) => (
          <div key={index} className="host-list-card">
            {/* Date Row */}
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <i className="far fa-calendar-alt" />
                </span>
                {t("date")}
              </span>
              <span className="host-list-value">
                {data?.date ? data?.date : "-"}
              </span>
            </div>

            {/* Duration Row */}
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <i className="fas fa-phone-alt" />
                </span>
                {t("duration_sec")}
              </span>
              <span className="host-list-value">
                {data?.callDurationSeconds ? data?.callDurationSeconds : 0}
              </span>
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "rgba(255,255,255,0.55)",
            fontSize: "16px",
            background: "transparent",
            borderRadius: "12px",
          }}
        >
          {t("no_data_found")}
        </div>
      )}
    </div>
  );
};

export default VideoCall;
